/**
 * DESIGN.md §7.2 — Plain Text Link.
 * Bare text link, no icon, no background. Uses label/md-med (16/20
 * medium · −0.25px). State colors per §3.1: default = text/on-action-2,
 * hover = text/hover-1, click = text/click-1.
 */
import type { AnchorHTMLAttributes } from 'react';
import { cn } from '../lib/cn.js';

export interface PlainTextLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {}

const BASE =
  'font-label font-medium text-label-md transition-colors text-text-on-action-2 hover:text-text-hover-1 active:text-text-click-1';

export function PlainTextLink({ className, ...props }: PlainTextLinkProps) {
  return <a className={cn(BASE, className)} {...props} />;
}
